import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import MUIDataTable from 'mui-datatables';

export default function ClientTable({ data, onRowClick }) {
  const filtered = [];

  filtered.push(...data);

  // TODO: Use internal-admin and client-admin roles to determine access to clients
  // if ('roles' in user) {
  //  const roleKeys = Object.keys(user.roles);
  //  for (let i = 0; i < roleKeys.length; i += 1) {
  //    const role = roleKeys[i];
  //    for (let j = 0; j < user.roles[role].length; j += 1) {
  //      const cid = user.roles[role][j];
  //      filtered.push(...data.filter(client => client.name === cid));
  //    }
  //  }
  // }

  return (
    <Paper>
      <MUIDataTable
        columns={[
          {
            label: 'ID',
            name: 'id',
            options: {
              display: false,
            },
          },
          {
            label: 'Name',
            name: 'name',
          },
          {
            label: 'Billing Address',
            name: 'billingAddressLine1',
          },
          {
            label: 'Billing Address 2',
            name: 'billingAddressLine2',
          },
          {
            label: 'City',
            name: 'billingAddressCity',
          },
          {
            label: 'State',
            name: 'billingAddressState',
          },
          {
            label: 'Zip',
            name: 'billingAddressZip',
          },
        ]}
        data={filtered}
        title="Clients"
        options={{
          filter: false,
          print: false,
          selectableRowsHeader: false,
          selectableRowsHideCheckboxes: true,
          viewColumns: false,
          onRowClick: rowData => onRowClick(rowData[0]),
        }}
      />
    </Paper>
  );
}

ClientTable.defaultProps = {
  onRowClick: () => {},
};

ClientTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      billingAddressLine1: PropTypes.string,
      billingAddressLine2: PropTypes.string,
      billingAddressCity: PropTypes.string,
      billingAddressState: PropTypes.string,
      billingAddressZip: PropTypes.string,
    })
  ).isRequired,
  onRowClick: PropTypes.func,
  // user: PropTypes.shape({
  //  id: PropTypes.string,
  //  roles: PropTypes.shape({
  //    app: PropTypes.arrayOf(PropTypes.string),
  //  }),
  // }).isRequired,
};
